import _ from "lodash";

import * as getElement from '@/api/crm/guestSegmentation/getElement';
import * as addLabel from '@/api/crm/guestSegmentation/addLabel';
import * as addInterest from '@/api/crm/guestSegmentation/addInterest';
import * as deleteLabel from '@/api/crm/guestSegmentation/deleteLabel';
import * as deleteInterest from '@/api/crm/guestSegmentation/deleteInterest';

export default {
    namespaced: true,
    state: {
        labels: [],
        interests: [],
    },
    mutations: {
        gotElement(state, result) {
            state.labels = result.labels;
            state.interests = result.interests;
        },
    },
    actions: {
        async get({ commit, getters }, force = true) {
            if (!force && getters.labels.length > 0) return;
            const result = await getElement.get();
            if (result) commit("gotElement", result);
        },
        async addLabel({ dispatch }, value) {
            await addLabel.post(value);
            await dispatch("get")
        },
        async addInterest({ dispatch }, value) {
            await addInterest.post(value);
            await dispatch("get")
        },
        async deleteLabel({ dispatch }, value) {
            await deleteLabel.del(value);
            await dispatch("get")
        },
        async deleteInterest({ dispatch }, value) {
            await deleteInterest.del(value);
            await dispatch("get")
        },

    },
    getters: {
        labels: state => state.labels,
        interests: state => state.interests,
    }
};
